/**
 * @flow
 * @relayHash e8bc97888c3d2fda35f8c7528aeac869
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FavoriteSellerInput = {|
  sellerPk: string,
  userId: string,
  favoriteId?: ?string,
  clientMutationId?: ?string,
|};
export type PdpSharedFollowDealerMutationVariables = {|
  input: FavoriteSellerInput,
  userId: string,
|};
export type PdpSharedFollowDealerMutationResponse = {|
  +favoriteSeller: ?{|
    +seller: ?{|
      +id: string,
      +favoritesByUser: ?$ReadOnlyArray<?{|
        +serviceId: ?string
      |}>,
    |}
  |}
|};
export type PdpSharedFollowDealerMutation = {|
  variables: PdpSharedFollowDealerMutationVariables,
  response: PdpSharedFollowDealerMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FavoriteSellerInput!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "FavoriteSellerInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userId",
    "type": "String!"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpSharedFollowDealerMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpSharedFollowDealerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "PdpSharedFollowDealerMutation",
    "id": "app-buyer-finding/209.0.0-2019-03-27T14:13:29.601Z/PdpSharedFollowDealerMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd966d29320daefd69c4375c04412618c';
module.exports = node;
